import * as yup from 'yup';
import { ECicaafTipoEntidade, ECicaafSituacaoCadastral, ELocalizacaoUnidade } from 'interfaces/cicaaf.interface';
import { validarCPF } from 'utils/uteis';

export const dadosGeraisValidationSchema = yup.object().shape({
    cicaaf_uuid: yup.string(),

    entity_type: yup
        .string()
        .oneOf(Object.values(ECicaafTipoEntidade), 'Tipo de entidade inválido')
        .required('Tipo de entidade é obrigatório'),

    identification: yup
        .string()
        .required('CPF/CNPJ é obrigatório')
        .test('cpf-cnpj-validation', 'CPF/CNPJ inválido', function (value) {
            const { isCpf } = this.parent;

            if (!value) return false;

            if (isCpf) {
                const cpf = value.replace(/\D/g, '');
                if (cpf.length !== 11) {
                    return false;
                }
                return validarCPF(value);
            } else {
                // Validação de CNPJ - remove caracteres especiais e verifica se tem 14 dígitos
                const cnpj = value.replace(/\D/g, '');
                return cnpj.length === 14;
            }
        }),

    entity_name: yup
        .string()
        .required('Nome/Razão Social é obrigatório')
        .min(2, 'Nome/Razão Social deve ter pelo menos 2 caracteres'),

    isCpf: yup.boolean().required(),

    city: yup
        .string()
        .required('Cidade é obrigatória'),

    has_active_caf: yup
        .boolean()
        .nullable()
        .required('Campo obrigatório'),

    cnpj_status: yup
        .string()
        .nullable()
        .when('isCpf', {
            is: false,
            then: (schema) => schema
                .oneOf(Object.values(ECicaafSituacaoCadastral), 'Situação cadastral inválida')
                .required('Situação cadastral do CNPJ é obrigatória'),
            otherwise: (schema) => schema.nullable()
        }),

    location_type: yup
        .string()
        .nullable()
        .oneOf(Object.values(ELocalizacaoUnidade), 'Localização da unidade inválida')
        .required('Localização da unidade é obrigatória'),

    belongs_to_association_cooperative: yup
        .boolean()
        .nullable()
        .when('entity_type', {
            is: ECicaafTipoEntidade.AGROINDUSTRY,
            then: (schema) => schema.required('Campo obrigatório para agroindústria'),
            otherwise: (schema) => schema.nullable()
        }),

    parent_association_cooperative_uuid: yup
        .string()
        .nullable()
        .when(['entity_type', 'belongs_to_association_cooperative'], {
            is: (entity_type: string, belongs_to_association_cooperative: boolean) =>
                entity_type === ECicaafTipoEntidade.AGROINDUSTRY
                && belongs_to_association_cooperative === true,
            then: (schema) => schema.required('Associação ou cooperativa é obrigatória'),
            otherwise: (schema) => schema.nullable()
        })
});
